export const MarginTopClasses = {
  MARGIN_TOP_NEGATIVE_XL: ['wf--mt-48'],
  MARGIN_TOP_NEGATIVE_LG: ['wf--mt-32'],
  MARGIN_TOP_NEGATIVE_BASE: ['wf--mt-20'],
  MARGIN_TOP_NEGATIVE_SM: ['wf--mt-12'],
  MARGIN_TOP_NEGATIVE_XS: ['wf--mt-4'],
  MARGIN_TOP_NEGATIVE_XXS: ['wf--mt-2'],
  MARGIN_TOP_NONE: ['wf-mt-0'],
  MARGIN_TOP_XXS: ['wf-mt-2'],
  MARGIN_TOP_XS: ['wf-mt-4'],
  MARGIN_TOP_SSM: ['wf-mt-7'],
  MARGIN_TOP_SM: ['wf-mt-12'],
  MARGIN_TOP_BASE: ['wf-mt-20'],
  MARGIN_TOP_LG: ['wf-mt-32'],
  MARGIN_TOP_XL: ['wf-mt-48'],
}

export const MarginBottomClasses = {
  MARGIN_BOTTOM_NEGATIVE_XL: ['wf--mb-48'],
  MARGIN_BOTTOM_NEGATIVE_LG: ['wf--mb-32'],
  MARGIN_BOTTOM_NEGATIVE_BASE: ['wf--mb-20'],
  MARGIN_BOTTOM_NEGATIVE_SM: ['wf--mb-12'],
  MARGIN_BOTTOM_NEGATIVE_XS: ['wf--mb-4'],
  MARGIN_BOTTOM_NEGATIVE_XXS: ['wf--mb-2'],
  MARGIN_BOTTOM_NONE: ['wf-mb-0'],
  MARGIN_BOTTOM_XXS: ['wf-mb-2'],
  MARGIN_BOTTOM_XS: ['wf-mb-4'],
  MARGIN_BOTTOM_SSM: ['wf-mb-7'],
  MARGIN_BOTTOM_SM: ['wf-mb-12'],
  MARGIN_BOTTOM_BASE: ['wf-mb-20'],
  MARGIN_BOTTOM_LG: ['wf-mb-32'],
  MARGIN_BOTTOM_XL: ['wf-mb-48'],
}

export const MarginLeftClasses = {
  MARGIN_LEFT_NEGATIVE_XL: ['wf--ml-48'],
  MARGIN_LEFT_NEGATIVE_LG: ['wf--ml-32'],
  MARGIN_LEFT_NEGATIVE_BASE: ['wf--ml-20'],
  MARGIN_LEFT_NEGATIVE_SM: ['wf--ml-12'],
  MARGIN_LEFT_NEGATIVE_XS: ['wf--ml-4'],
  MARGIN_LEFT_NEGATIVE_XXS: ['wf--ml-2'],  
  MARGIN_LEFT_NONE: ['wf-ml-0'],
  MARGIN_LEFT_XXS: ['wf-ml-2'],
  MARGIN_LEFT_XS: ['wf-ml-4'],
  MARGIN_LEFT_SSM: ['wf-ml-7'],
  MARGIN_LEFT_SM: ['wf-ml-12'],
  MARGIN_LEFT_BASE: ['wf-ml-20'],
  MARGIN_LEFT_LG: ['wf-ml-32'],
  MARGIN_LEFT_XL: ['wf-ml-48'],
}

export const MarginRightClasses = {
  MARGIN_RIGHT_NEGATIVE_XL: ['wf--mr-48'],
  MARGIN_RIGHT_NEGATIVE_LG: ['wf--mr-32'],
  MARGIN_RIGHT_NEGATIVE_BASE: ['wf--mr-20'],
  MARGIN_RIGHT_NEGATIVE_SM: ['wf--mr-12'],
  MARGIN_RIGHT_NEGATIVE_XS: ['wf--mr-4'],
  MARGIN_RIGHT_NEGATIVE_XXS: ['wf--mr-2'],  
  MARGIN_RIGHT_NONE: ['wf-mr-0'],
  MARGIN_RIGHT_XXS: ['wf-mr-2'],
  MARGIN_RIGHT_XS: ['wf-mr-4'],
  MARGIN_RIGHT_SSM: ['wf-mr-7'],
  MARGIN_RIGHT_SM: ['wf-mr-12'],
  MARGIN_RIGHT_BASE: ['wf-mr-20'],
  MARGIN_RIGHT_LG: ['wf-mr-32'],
  MARGIN_RIGHT_XL: ['wf-mr-48'],
}